module.exports = __webpack_public_path__ + "static/img/no-cart.a68d9c67.png";